import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "./button";
import { cn } from "../lib/utils";

interface ErrorStateProps {
  /** Error object or error message string */
  error: Error | string;
  /** Retry button click handler. If not provided, retry button is hidden */
  onRetry?: () => void;
  /** Custom class name */
  className?: string;
  /** Title text (defaults to "Something went wrong") */
  title?: string;
  /** Retry button label (defaults to "Try again") */
  retryLabel?: string;
}

export function ErrorState({
  error,
  onRetry,
  className,
  title = "Something went wrong",
  retryLabel = "Try again",
}: ErrorStateProps) {
  const errorMessage = typeof error === "string" ? error : error.message;

  return (
    <div
      className={cn("animate-fade-in flex min-h-[300px] items-center justify-center", className)}
    >
      <div className="max-w-sm text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
          <AlertCircle className="h-8 w-8 text-destructive" />
        </div>
        <h3 className="mb-2 text-lg font-semibold">{title}</h3>
        <p className="mb-6 text-sm text-muted-foreground">{errorMessage}</p>
        {onRetry && (
          <Button onClick={onRetry} variant="outline">
            <RefreshCw className="mr-2 h-4 w-4" />
            {retryLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
